<div class="w-full h-[calc(100vh-8.5rem)] flex flex-row gap-6">
    <!-- Left Panel: Map Area (75%) -->
    <div class="flex-1 flex flex-col relative h-full gap-4">
        <!-- Map Header -->
        <div class="p-4 bg-(--card-background) rounded-xl shadow-sm border border-slate-200 flex flex-col gap-4">
            <div class=" flex items-center justify-between">
                <div class="flex items-center gap-4">
                    <h2 class="text-slate-800 text-lg font-bold m-0">平面圖 - {{ currentFloor() }}樓</h2>
                    <p-selectButton unselectable [options]="floorOptions" [ngModel]="currentFloor()"
                        (ngModelChange)="currentFloor.set($event)" optionLabel="label" optionValue="value"
                        size="small">
                        <ng-template pTemplate="item" let-item>
                            <span [ngClass]="{'text-red-500 font-bold': floorAlarmStatus()[item.value]}">
                                {{ item.label }}
                            </span>
                        </ng-template>
                    </p-selectButton>
                </div>
                <div class="flex items-center gap-2">
                    <!-- <p-button *appHasPermission="'儀錶板_edit'" 
                        [label]="isEditable() ? '關閉編輯點位' : '開啟編輯點位'" 
                        [severity]="isEditable() ? 'danger' : 'secondary'" 
                        [icon]="isEditable() ? 'pi pi-lock-open' : 'pi pi-lock'" 
                        (onClick)="isEditable.set(!isEditable())"></p-button>
                    <p-button *appHasPermission="'儀錶板_edit'" label="匯出位置設定檔" severity="secondary" icon="pi pi-download" (onClick)="exportDeviceConfig()"></p-button> -->
                    <p-button *appHasPermission="'儀錶板_edit'" label="設備群控控制" (onClick)="showGroupControlDialog()"></p-button>
                </div>
            </div>
            <!-- Category Filters -->
            <div class="flex gap-2">
                @for (opt of filterOptions(); track opt.type) {
                <p-button [label]="opt.label + ' (' + opt.count + ')'" [icon]="'ci ' + opt.icon"
                    (onClick)="toggleFilter(opt.type)"
                    severity="secondary"
                    [text]="activeFilters().length > 0 && !activeFilters().includes(opt.type)"
                    [styleClass]="(activeFilters().length === 0 || activeFilters().includes(opt.type)) ? '!bg-slate-800 !text-white' : '!text-slate-500'"
                    size="small">
                </p-button>
                }
            </div>
            <!-- Legend Overlay -->
            <div class="flex items-center gap-3">
                <div class="flex items-center gap-1.5">
                    <div class="w-2.5 h-2.5 rounded-full bg-[#3FBAB9]"></div> 正常
                </div>
                <div class="flex items-center gap-1.5">
                    <div class="w-2.5 h-2.5 rounded-full bg-[#FB2C36] animate-pulse"></div> 警告
                </div>
                <div class="flex items-center gap-1.5">
                    <div class="w-2.5 h-2.5 rounded-full bg-[#9F9F9F]"></div> 報廢/維修
                </div>
            </div>
        </div>

        <!-- Map Container -->
        <div class="flex-1 relative">
            <div class="w-full h-full bg-(--card-background) rounded-xl border border-slate-200 shadow-sm p-2">
                <div #mapContainer id="map" class="w-full h-full z-0 rounded-lg"></div>
            </div>
        </div>
    </div>
    <!-- Right Panel: Widgets -->
    <div class="w-[380px] shrink-0 bg-(--ground-background) h-full">
        <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
            <div class="flex flex-col gap-4 pb-2">
                <!-- Block 1: System Stats (Top) -->
                <div class="bg-(--card-background) rounded-xl shadow-sm border border-slate-200">
                    <app-system-stats></app-system-stats>
                </div>

                <!-- Block 2: Latest Alarms (Middle) -->
                <div class="bg-(--card-background) rounded-xl shadow-sm border border-slate-200">
                    <app-latest-alarms (alarmClick)="onAlarmClick($event)"></app-latest-alarms>
                </div>

                <!-- Block 3: Power Analysis (Bottom) -->
                <div class="bg-(--card-background) rounded-xl shadow-sm border border-slate-200">
                    <app-power-analysis [data]="powerAnalysisData()"></app-power-analysis>
                </div>

                <!-- Block 4: Contract Capacity -->
                <div class="bg-(--card-background) rounded-xl shadow-sm border border-slate-200">
                    <app-contract-capacity [data]="powerAnalysisData()?.contractCapacity"></app-contract-capacity>
                </div>

                <!-- Block 5: Air Quality -->
                <div class="bg-(--card-background) rounded-xl shadow-sm border border-slate-200">
                    <app-air-quality [data]="airQuality()"></app-air-quality>
                </div>

                <!-- Block 6: Meeting Rooms -->
                <div class="bg-(--card-background) rounded-xl shadow-sm border border-slate-200">
                    <app-meeting-rooms [rooms]="meetingRooms"></app-meeting-rooms>
                </div>

                <div class="bg-(--card-background) rounded-xl shadow-sm border border-slate-200">
                    <div class="grid grid-cols-1 p-4 gap-2">
                        <!-- <p-button label="預約會議室入口" icon="pi pi-calendar-plus" styleClass="w-full" (onClick)="openMeetingRoomPortal()"></p-button> -->
                        <p-button label="拖播系統入口" icon="pi pi-desktop" styleClass="w-full" (onClick)="openVnc()"></p-button>
                    </div>
                </div>
            </div>
        </p-scrollPanel>
    </div>
</div>

<!-- Group Control Dialog -->
<p-dialog header="設備群控控制" [visible]="displayGroupControl()" (visibleChange)="displayGroupControl.set($event)" [modal]="true" appendTo="body"
    [draggable]="false" [resizable]="false">
    <div class="flex flex-col gap-4 py-2">
        @for (floorData of groupControlData(); track floorData.floor) {
        <!-- Floor Card -->
        <div class="bg-(--card-background) rounded-xl border border-slate-200 p-4 flex flex-col gap-4 shadow-sm">
            <!-- Floor Header -->
            <div class="flex justify-between items-center">
                <span class="text-lg font-bold text-slate-800">{{ floorData.floor }}</span>
                <p-button label="全關" [disabled]="!floorData.active" [severity]="floorData.active ? undefined : 'secondary'" size="small"
                    (onClick)="confirmTurnOffFloor(floorData.floor)" styleClass="font-bold px-6"></p-button>
            </div>

            <!-- Devices List -->
            <div class="flex flex-col gap-3">
                @for (device of floorData.devices; track device.name) {
                <!-- Device Item -->
                <div class="flex items-center justify-between p-3 rounded-lg border" [ngClass]="device.bgClass">
                    <div class="flex items-center gap-3">
                        <!-- Icon Box -->
                        <div class="w-10 h-10 rounded-lg flex items-center justify-center text-white shadow-sm"
                            [ngClass]="device.color">
                            <i [class]="device.icon"></i>
                        </div>
                        <!-- Texts -->
                        <div class="flex flex-col">
                            <span class="text-sm font-bold text-slate-800 mb-0.5">{{ device.name }}</span>
                            <span class="text-xs text-slate-500">{{ device.status }}</span>
                        </div>
                    </div>
                    <!-- Action Button -->
                    <p-button label="全關" [disabled]="!device.active" [severity]="device.active ? undefined : 'secondary'"
                        (onClick)="confirmTurnOffDeviceCategory(floorData.floor, device.name)" size="small"
                        styleClass="font-bold px-4 text-xs"></p-button>
                </div>
                }
            </div>
        </div>
        }
    </div>
</p-dialog>

<!-- noVNC Dialog -->
<p-dialog header="拖播系統 (noVNC)" [visible]="displayVnc()" (visibleChange)="displayVnc.set($event)" [modal]="true" appendTo="body"
    [draggable]="true" [resizable]="true" [style]="{width: '85vw'}" [maximizable]="true"
    (onMaximize)="isVncMaximized.set($event.maximized)">
    <div class="w-full" [style.height]="isVncMaximized() ? 'calc(100vh - 120px)' : '75vh'">
        <iframe [src]="vncUrl()" class="w-full h-full border-none block rounded-md" allowfullscreen></iframe>
    </div>
</p-dialog>

<!-- Group Control Confirm Dialog -->
<p-dialog header="確認設定" [visible]="displayConfirmDialog()" (visibleChange)="displayConfirmDialog.set($event)" [modal]="true" appendTo="body">
    <div class="flex flex-col gap-8 py-8 px-4">
        <p class="text-lg text-slate-500 m-0">
            確定要將 {{ getConfirmMessage() }} 設定為 
            <span class="font-bold text-amber-500 text-xl">關</span> 嗎？
        </p>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="取消" [outlined]="true" severity="secondary" (onClick)="cancelTurnOff()"></p-button>
        <p-button label="確定" (onClick)="executeTurnOff()"></p-button>
    </ng-template>
</p-dialog>